import { useMemo, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import NewsCard from '@/components/feature/NewsCard';
import Pagination from '@/pages/category/components/Pagination';
import { newsList } from '@/mocks/news';

const PAGE_SIZE = 6;

export default function News() {
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const paged = useMemo(
    () => newsList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [page]
  );

  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <Navbar />
      <div className="h-16 md:h-[72px]" />

      <main className="flex-1">
        <div className="w-full px-4 md:px-8 py-6 md:py-10">
          <Breadcrumb items={[{ label: '影视资讯' }]} />

          <div className="mt-6">
            <h1 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950">
              影视资讯
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
              了解《美国式禁忌4》及相关美剧电影的最新动态、幕后花絮与深度解析，掌握影视圈值得关注的每一件事。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-8">
            {paged.map((item) => (
              <NewsCard key={item.id} item={item} layout="grid" />
            ))}
          </div>

          <Pagination current={page} total={totalPages} onChange={setPage} />
        </div>
      </main>

      <Footer />
    </div>
  );
}